<template>
  <v-card  ref="form" v-if="show">
    <v-card-text class="d-flex justify-space-between">
      <h2 class="mt-2">{{ value.cabecalhoActions }}</h2>
      <v-btn color="primary" @click="$emit('goBack')" v-if="value.backAction">
        {{ $t('button.go_back') }}
      </v-btn>
      <span v-show="!avaliableActions">{{avaliableActions}}</span>
    </v-card-text>
    <draggable
      class="list-group"
      v-bind="dragOptions"
      :list="value.actions"
      @start="drag = true"
      @end="drag = false"
  >
  <transition-group type="transition" :name="!drag ? 'flip-list' : null">
    <v-card
      class="mx-2 mb-1 list-group-item"
      v-for="(action, i) in value.actions"
      :key="action.actionName + '_' + i"
      :class="{ 'disabled-card-action': action.disableAction, 'select-card': (selectecCard != null && selectecCard == i) }"
    >
      <v-card-title class="headline  justify-space-between">{{action.actionName}}
        <span>
           <span v-if="action.disableAction" class="subtitle-2 red--text" >Desabilitado</span>
        <v-tooltip v-if="selectecCard == null" bottom>
          <template v-slot:activator="{ on }" >
            <v-btn  v-on="on" @click="selectToMove(i)" :disabled="(selectecCard != null && selectecCard == i)" icon color="primary"> <v-icon>mdi-folder-move</v-icon></v-btn>
          </template>
          <span>{{$t('workflow.card_action.nest')}}</span>
        </v-tooltip>
         <v-tooltip  v-if="(selectecCard != null && selectecCard != i) && isSubSupportAction(action.actionType)" bottom>
          <template v-slot:activator="{ on }"  >
            <v-btn  v-on="on" @click="receiveSelectedAcion(i)" icon color="red"> <v-icon>mdi-folder-download</v-icon></v-btn>
          </template>
          <span>{{$t('workflow.card_action.insert')}}</span>
        </v-tooltip>
        <v-tooltip  v-if="selectecCard != null" left>
          <template v-slot:activator="{ on }"  >
            <v-btn v-on="on"  @click="selectecCard = null"  icon color="yellow"> <v-icon>mdi-cached</v-icon></v-btn>
          </template>
          <span>{{$t('workflow.card_action.unravel')}}</span>
        </v-tooltip>
         <v-tooltip  v-if="value.backAction!= null" bottom>
          <template v-slot:activator="{ on }"  >
            <v-btn v-on="on"  @click="extractAction(i)"  icon color="red"> <v-icon>mdi-reply</v-icon></v-btn>
          </template>
          <span>{{$t('workflow.card_action.extract')}}</span>
        </v-tooltip>
        </span>
       </v-card-title>
      <v-card-subtitle class = "">
        <span > {{resumeActionName(action.actionType)}} </span>
      <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on"> mdi-information-outline </v-icon>
          </template>
          <span>{{action.actionType}}</span>
        </v-tooltip>
      </v-card-subtitle>
      <v-card-text v-if="action.actionDescription"> {{ $t('keywords.description') }}: {{ action.actionDescription }} </v-card-text>

       <v-card-actions>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$emit('removeAction', i)" left color="red">
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('workflow.card_action.action.delete') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$emit('addEmptyActionAtPosition', i + 1)" left color="primary">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('workflow.card_action.action.add_below') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="copyActualAction(action, i + 1)" left color="primary">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('workflow.card_action.action.duplicate') }}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip
          left
          v-if="hasChildren(action.actionType)"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon @click="$emit('addSideAction', action)" v-on="on" color="orange">
              <v-icon>mdi-format-text-wrapping-overflow</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('workflow.card_action.action.alternative_flow') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="$emit('editAction', action)" v-on="on" color="primary">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('workflow.card_action.action.edit') }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </transition-group>
  </draggable>
    <div class="text-center mt-4 pb-3">
      <v-btn class="mx-2" fab dark small color="primary" @click="$emit('addEmptyAction')">
        <v-icon icon dark>mdi-plus</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import draggable from 'vuedraggable'
import { mapState } from 'vuex'

export default {
  name: 'CardAction',

  props: {
    ownerActions: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: () => {}
    },
    backAction: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      selectecCard: null,
      subLevelActions: [
        'br.com.senior.plutaoapp.workflow.actions.IfAction',
        'br.com.senior.plutaoapp.workflow.actions.ForAction',
        'br.com.senior.plutaoapp.workflow.actions.ForMapAction',
        'br.com.senior.plutaoapp.workflow.actions.TryCatchAction'
      ],
      drag: false
    }
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  computed: {
    ...mapState(['avaliableActions']),
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },

  components: {
    draggable
  },

  methods: {
    extractAction (index) {
      this.value.backAction.actions.push(this.value.actions[index])
      this.value.actions.splice(index, 1)
      this.$forceUpdate()
    },
    isSubSupportAction (actionType) {
      return this.subLevelActions.find((action) => {
        return action === actionType
      })
    },
    receiveSelectedAcion (i) {
      if (this.value.actions[i].actions === null || this.value.actions[i].actions === undefined) {
        this.value.actions[i].actions = []
      }
      this.value.actions[i].actions.push(this.value.actions[this.selectecCard])
      this.value.actions.splice(this.selectecCard, 1)
      this.selectecCard = null
    },
    selectToMove (index) {
      this.selectecCard = index
    },
    getColor (color) {
      return !this.value.disableAction ? 'grey lighten-2' : color
    },
    resumeActionName (fullActionName) {
      if (!fullActionName) return ''
      const split = fullActionName.split('.')
      return split[split.length - 1]
    },
    hasChildren (type) {
      return this.subLevelActions.indexOf(type) >= 0
    },
    copyActualAction (action, index) {
      const eventData = {
        index: index,
        value: action
      }
      this.$emit('copyActualAction', eventData)
    }
  }
}
</script>

<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.7;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.disabled-card-action{
  opacity: 0.6;
}
.select-card{
  border-width: 2px;
  border-style: solid;
  border-color: rgb(73, 73, 72);
}
</style>
